export function trackEarlyAccessEvent(viewModel, eventName, parameters = {}) {
  if (!viewModel || !viewModel.$gtag || typeof viewModel.$gtag.event !== 'function') {
    return false;
  }

  viewModel.$gtag.event(eventName, parameters);
  return true;
}
